"use strict";import{html as r}from"@cisco-u/base";export function arch({height:e=276,width:t=251,hidden:l=!1,title:a="",fill:i="#C3C4C5"}={}){return r`<svg
    width=${t}
    height=${e}
    viewBox="0 0 251 276"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="${l?"true":"false"}"
    aria-label="${a}"
  >
    <path
      d="M0 125.075C0 55.9982 55.998 6.10352e-05 125.075 6.10352e-05C194.152 6.10352e-05 250.15 55.9981 250.15 125.075V275.165L0 275.165L0 125.075Z"
      fill=${i}
    />
  </svg>`}
//# sourceMappingURL=arch.js.map
